<main>
  <h2>{{"MAIN_APP_CAMERA.meineNotizen" | translate}}</h2>
  <mat-card class="card-margin" [class.unread] = "!note.wasRead" *ngFor="let note of dbNotizen">
    <div class="list-item-layout" *ngIf="innerWidth > 480">
        <div class="list-item-first-box">
            <mat-icon *ngIf="note.wasRead" class="green">done</mat-icon>
            <mat-icon *ngIf="!note.wasRead" class="red">warning</mat-icon>
            <div class="black">{{note.modified | datumFormat}}</div>
         </div>

       <div class="list-box">
        <div *ngIf="note.description">{{note.description}}</div>
       </div>
       
       <div class="list-box"><div>{{note.createdBy}}</div></div>

       <div class="list-box flex-box">
        <button mat-mini-fab class="vinavonButton" (click)="showNotizDetail(note)">
          <mat-icon>edit</mat-icon>
        </button>
       </div>
    </div>

    <div class="list-item-layout-mobile" *ngIf="innerWidth <= 480">
      <div class="list-item-first-box-mobile">
        <mat-icon *ngIf="note.wasRead" class="green">done</mat-icon>
        <mat-icon *ngIf="!note.wasRead" class="red">warning</mat-icon>
        <div class="black small-font">{{note.modified | datumFormat}}</div>
      </div>

       <div class="list-box-mobile">
        <div *ngIf="note.description">{{note.description}}</div>
        <div><strong>{{note.createdBy}}</strong></div>
       </div>
      
       <div class="list-box flex-box">
        <button mat-mini-fab class="vinavonButton" (click)="showNotizDetail(note)">
          <mat-icon>edit</mat-icon>
        </button>
       </div>
    </div>
  </mat-card>
</main>

